import localesPt from '@/views/Auth/i18n/localePt';

export default {
  pt: {
    ...localesPt.pt,
    SEO_TITLE: 'Conecte-se',
    SEO_DESCRIPTION: 'Inicie a sessão para continuar aprendendo',
    FORM_TITLE: 'Bem-vindo',
    FORM_DESCRIPTION: 'Comece seu aprendizado com Crehana para empresas.',
    INPUT_EMAIL_LABEL: 'E-mail',
    INPUT_EMAIL_HINT: 'Digite seu e-mail',
    INPUT_PASSWORD_LABEL: 'Senha',
    INPUT_PASSWORD_HINT: 'Digite seu senha',
    FORGOT_PASSWORD: 'Esqueceu sua senha?',
    BUTTON_SUBMIT_LABEL: 'Entrar',
    FIRST_TIME_IN_CREHANA: 'É a primeira vez que usa Crehana?',
    REGISTER: 'Cadastrar-se',
    LOGIN_WITH_YOUR_ORGANIZATION: 'Comece com sua organização',
    LOGIN_WITH_YOUR_ORGANIZATION_DESKTOP: 'Faça login com sua organização',
  },
};
